export async function verifyAuthorizationCode(authCode, schoolNameToSend, role, email) {
  try {
    const response = await fetch('https://fm407nxajh.execute-api.us-west-2.amazonaws.com/authorizeTeacher', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        school: schoolNameToSend,
        authorizationCode: authCode,
        role: role, 
        email: email
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Authentication failed');
    }

    const data = await response.json();
    return data.valid;
  } catch (error) {
    console.error('Error verifying authorization code:', error);
    throw new Error('Authentication failed. Please check your code and try again.');
  }
}